import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "AppPager"
}
const _hoisted_2 = { class: "AppPager-scrollTop" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 24 24",
  width: "22",
  height: "22",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z",
    "vector-effect": "non-scaling-stroke"
  })
], -1)
const _hoisted_4 = { class: "AppPager-btnHolder" }
const _hoisted_5 = { class: "AppPager-pager" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PagerItem = _resolveComponent("PagerItem")!

  return (_ctx.pager.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollTop()))
          }, [
            _hoisted_3,
            _createElementVNode("span", null, _toDisplayString(_ctx.backToTopLabel), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.nextPageUrl)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadMore(_ctx.nextPageUrl))),
                type: "button",
                class: "ButtonBase ButtonBase--sm"
              }, _toDisplayString(_ctx.nextPageLabel), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pager, (item) => {
            return (_openBlock(), _createBlock(_component_PagerItem, { pagerItem: item }, null, 8, ["pagerItem"]))
          }), 256))
        ])
      ]))
    : _createCommentVNode("", true)
}